module.exports = __webpack_public_path__ + "static/p8-5952baf8722276ed2e95088d9a95edde.png";